module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header",
    class: {
      'is-open': _vm.isOpen
    }
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_c('h1', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Paul Thibault")])], 1), _vm._v(" "), _c('div', {
    staticClass: "navigation",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isOpen = !_vm.isOpen
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('nav', {
    staticClass: "nav"
  }, [_c('ul', {
    staticClass: "nav-list no-style"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', {
    staticClass: "inner"
  }, [_vm._v("à propos")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/project"
    }
  }, [_c('span', {
    staticClass: "inner"
  }, [_vm._v("réalisations")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_c('span', {
    staticClass: "inner"
  }, [_vm._v("contact")])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation__burger"
  }, [_c('div', {
    staticClass: "navigation__burger-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "navigation__burger-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation__cross"
  }, [_c('div', {
    staticClass: "navigation__cross-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "navigation__cross-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d6e4022","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader.vue
// module id = 171
// module chunks = 1